import { FC } from 'react'

import {
  Button,
  ButtonColors,
  ButtonSizes,
  ButtonVariants
} from '@inno-ui/button'
import { AnimatePresence, motion } from 'motion/react'
import { useTranslation } from 'react-i18next'

import styles from './OnboardingIntro.module.scss'
import { OnboardingIntroProps } from './OnboardingIntro.types'

export const OnboardingIntro: FC<OnboardingIntroProps> = ({
  handleStartTour,
  handleSkipTour,
  hasCompletedTour
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'onboarding.intro'
  })

  return (
    <AnimatePresence>
      {!hasCompletedTour && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={styles.overlay}
        >
          <motion.div
            initial={{ scale: 1.2 }}
            animate={{ scale: 1 }}
            exit={{ scale: 1.2 }}
            className={styles.modal}
            onClick={e => e.stopPropagation()}
          >
            <div className={styles.card}>
              <div className={styles.content}>
                <div className={styles.imageWrapper}>
                  <img
                    src='/onboarding-illustration.webp'
                    alt='Onboarding Illustration'
                    className={styles.image}
                  />
                  <div className={styles.gradient} />
                </div>
                <div className={styles.textWrapper}>
                  <h1>{t('title')}</h1>
                  <p>{t('description')}</p>
                </div>
                <div className={styles.progressbar}>
                  <div className={styles.progress} />
                </div>
                <div className={styles.buttonWrapper}>
                  <Button
                    size={ButtonSizes.M}
                    variant={ButtonVariants.Light}
                    color={ButtonColors.Blue}
                    label={t('skip_tour')}
                    onClick={handleSkipTour}
                  />
                  <Button
                    size={ButtonSizes.M}
                    variant={ButtonVariants.Dark}
                    color={ButtonColors.Blue}
                    label={t('continue')}
                    onClick={handleStartTour}
                  />
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
